export default "__VITE_ASSET__B85czV8X__"